/** Valid State Category values. `ON`/`OFF` are used in business logic */
export const STATE_CATEGORY = {
  NONE: '',
  ON: 'ON',
  OFF: 'OFF',
  FILTRATION: 'FILTRATION',
  BACKWASH: 'BACKWASH',
  RELAX: 'RELAX',
  CEB: 'CEB',
  CIP: 'CIP',
  RECIRCULATION: 'RECIRCULATION',
  FORWARD_FLUSH: 'FORWARD_FLUSH',
  RINSE: 'RINSE',
  HEATING: 'HEATING',
  FILLING: 'FILLING',
} as const;

export type StateCategoryValue = (typeof STATE_CATEGORY)[keyof typeof STATE_CATEGORY];
